import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=ade508b6&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=babel&"
export * from "./videoList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade508b6",
  null
  
)

export default component.exports